import React from 'react';

// Formik validation
import { useFormik } from "formik";
import moment from 'moment';
import { Form, FormFeedback, Input } from 'reactstrap';
import * as Yup from "yup";

import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../shared';

export const AnalysisRequestEditReportModal = ({ props, showModal, setShowModal, modalRespInfo, modalHeader, rowInfo }) => {

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            authorizationStatus: rowInfo?.authorizationStatus, // Es un selector. Aqui va el número del valor del selector
            datedAt: moment.utc(rowInfo?.datedAt).format('YYYY-MM-DD'), // Es un selector de fecha
        },
        validationSchema: Yup.object({
            datedAt: Yup.string().required("Defina la fecha"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values);
            resetForm();
            setShowModal(false);
        }
    });

    const { className } = props;

    const onClosed = () => {
        validation.resetForm();
    }

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color='success'
                className='rounded-3 me-2'
                onClick={validation.handleSubmit}
                label='Guardar'
                outline={true}
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color='danger'
                className='rounded-3 me-3'
                onClick={() => setShowModal(false)}
                label='Cancelar'
                outline={true}
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    const title = (  
        <div className="d-flex ms-3 p-0">
            <label className="m-0 p-0">
                <h4 className="text-primary m-0 ps-4">{modalHeader}</h4>
            </label>
        </div>
    );

    return (
        <BaseCustomModal
            title={title}
            isModalOpen={showModal}
            handleCancel={() => setShowModal(false)}
            onClosed={onClosed}
            zIndex={9999}
            width="60%" 
            className={className}
            footer={buttons} 
        >
            <GradientDecorationLine />

            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                <div className="px-4 mx-3 mb-4">
                    <label htmlFor="exampleInputEmail1" className="text-primary">Status</label>
                    <select
                        required
                        defaultValue=""
                        name="authorizationStatus"
                        className="form-select text-primary rounded-3 mb-3"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.authorizationStatus || ""}
                    >
                        <option value="">Seleccione el status</option>
                        <option value="En Espera">En Espera</option>
                        <option value="Autorizado">Autorizado</option>
                        <option value="Rechazado">Rechazado</option>
                    </select>

                    <label className="text-primary">Fecha de atención</label>
                    <Input
                        name="datedAt"
                        className="form-control text-primary"
                        placeholder="Fecha estimada"
                        type="date"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.datedAt || ""}
                        invalid={validation.touched.datedAt && validation.errors.datedAt}
                    />
                    {validation.touched.datedAt && validation.errors.datedAt && (
                        <FormFeedback type="invalid">{validation.errors.datedAt}</FormFeedback>
                    )}
                </div>

                <GradientDecorationLine />
            </Form>
        </BaseCustomModal>
    );
};
